import { Controller } from "stimulus"
import axios from 'axios';
export class ModalFormBase extends Controller {
  static get targets() {
    return ['contentModal'];
  }
 
  
  initialize(){

  }

  new(e){

    this.renderForm(e.detail[0].response);
   
    $(this.contentModalTarget).modal('show');

  }

  onSubmitFail(e){
    this.renderForm(e.detail[2].response);
    
  }

  renderForm(response){
    let modal = this.contentModalTarget; 
    modal.querySelector('.modal-body').innerHTML = response;
  



  }



}



// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/controllers/modal_form_base.js